module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp12_9016.98fa68f0.png";